import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { State } from '../../services/global-state';
import { ValidationController } from 'aurelia-validation';
import { Uuid } from '../../helpers/uuid';
import { Merchant } from '../../models/merchant';

@autoinject
export class SelectMerchant {
	globalState: State;
	@bindable merchants: Array<Merchant>;
	@bindable selectedMerchant: Merchant;
	@bindable isMerchantRequired: boolean;
	@bindable addDefaultOption: boolean = true;
	label: string;
	select: string;
	errorMessage: string;
	@bindable validationController: ValidationController;
	uuid: string;
	@bindable showMerchantDisplayName: boolean = false;

	defaultOptionItem: Merchant = {
		merchantKey: -999,
		merchantName: '--- PLEASE SELECT ---',
		zid: '',
		createDate: new Date(),
		status: '',
		merchantDisplayName: '--- PLEASE SELECT ---',
		merchantSettings: {}
	};

	constructor(state: State, private i18n: I18N) {
		this.globalState = state;
		this.uuid = Uuid.next();
		this.label = this.i18n.i18next.t('consumerPortalEzPayMerchantSelect', { defaultValue: 'Select Merchant' });
		this.select = this.i18n.i18next.t('select', { defaultValue: '--Select--' });
		this.merchants = new Array<Merchant>();
	}

	sortItems(a, b, showDisplayName) {
		const optionADisplayName = showDisplayName ? (a.merchantDisplayName ?? a.merchantName) : a.merchantName;
		const optionBDisplayName = showDisplayName ? (b.merchantDisplayName ?? b.merchantName) : b.merchantName;
		if (optionADisplayName < optionBDisplayName) {
			return -1;
		}
		if (optionADisplayName > optionBDisplayName) {
			return 1;
		}
		return 0;
	}

	@computedFrom('merchants', 'getmerchants()')
	get merchantList(): Array<Merchant> {
		if (this.addDefaultOption && !this.merchants.find(x => x.merchantKey == this.defaultOptionItem.merchantKey)) {
			this.merchants = this.merchants.sort((a, b) => this.sortItems(a, b, this.showMerchantDisplayName));
			this.merchants.unshift(this.defaultOptionItem);
		}
		return this.merchants;
	}

	@computedFrom('merchantList')
	get merchantDescriptions(): string[] {
		return this.merchantList.map(b => this.showMerchantDisplayName ? (b.merchantDisplayName ?? b.merchantName) : b.merchantName).sort();
	}
}